// Web half of the shared nav model (src/lib/nav.ts): where each key goes and
// which icon draws it. Labels, groups and order are NOT here — they live in the
// model, which the phone vendors byte-identically. The phone's twin is
// mobile/src/components/navTargets.ts; the icons are chosen to match its
// Ionicons (home / pie-chart / stats-chart / analytics / settings, …).
import {
  BarChart3, BookOpen, Calculator, Crown, Gauge, Gift, Home, Hourglass, LineChart,
  PieChart, Plug, Settings, ShieldCheck, Sparkles, Users, Wallet, Wrench,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import type { NavKey } from '../lib/nav';

export const WEB_NAV: Record<NavKey, { to: string; icon: LucideIcon }> = {
  home: { to: '/app', icon: Home },
  portfolio: { to: '/app/portfolio', icon: PieChart },
  markets: { to: '/app/markets', icon: BarChart3 },
  progress: { to: '/app/insights', icon: LineChart },
  settings: { to: '/app/settings', icon: Settings },
  connect: { to: '/app/aggregation', icon: Plug },
  budgets: { to: '/app/budgets', icon: Wallet },
  household: { to: '/app/household', icon: Users },
  rewards: { to: '/app/wellness', icon: Gift },
  learn: { to: '/app/learn', icon: BookOpen },
  robo: { to: '/app/robo', icon: Gauge },
  ai: { to: '/app/ai', icon: Sparkles },
  // The public calculators hub — outside /app, un-authenticated, same SPA.
  calculators: { to: '/calculators', icon: Calculator },
  roadmap: { to: '/app/waiting', icon: Hourglass },
  plans: { to: '/app/plans', icon: Crown },
  privacy: { to: '/app/privacy', icon: ShieldCheck },
  founder: { to: '/app/founder', icon: Wrench },
};

/** Quick-action destinations that open a specific section rather than the page top. */
export const WEB_QUICK_ACTION_TO: Partial<Record<NavKey, string>> = {
  household: '/app/household?tab=nominees',
};
